import { register } from "@rill/loader";

register(
  {
    name: "listNotifications",
    meta: ["no-bust", "notification"],
    ttl: "2 hours",
  },
  async ({ api }, params) => {
    const { limit } = params;
    const res = await api("notification", {
      query: {
        limit: limit ? limit : false,
        sort: { createdAt: -1, date: -1 },
      },
    });

    const data = await res.json();
    // Handle new paginated format ({ docs, total }) vs legacy array format
    return limit ? data.docs : data;
  }
);

register(
  {
    name: "coachNotifications",
    meta: ["no-bust", "notification"],
    ttl: "2 hours",
  },
  async ({ api, locals }, { limit, skip, type, sort, read }) => {
    const query = {
      limit: limit + 1,
      skip,
      type,
      sort,
      read,
    };
    const res = await api("notification", {
      query,
    });
    const data = await res.json();
    // Handle new paginated format ({ docs, total })
    const notifications = data.docs;

    const hasNextPage = notifications.length > limit;
    if (hasNextPage) notifications.pop();

    const athletes = locals.activeUser.athletes || [];

    notifications.forEach((notification) => {
      const requester = athletes.find(
        ({ _id }) => _id === notification.requesterId
      );
      notification.requester = requester;
    });

    return {
      notifications,
      hasNextPage,
    };
  }
);
